// extracted by mini-css-extract-plugin
module.exports = {"thankYouContainer":"ThankYouMessage_thankYouContainer__pqkH+","thankYouTitle":"ThankYouMessage_thankYouTitle__HXTS4","thankYouMessage":"ThankYouMessage_thankYouMessage__zUaJK"};